import api from "../api/axios";

const categoryService = {
  getAll: () => api.get("/category/get-all-categories"),
  getById: (id) => api.get(`/category/get-category/${id}`),
  create: (data) => api.post("/category/create", data),
  update: (data) => api.post(`/category/update`, data),
  delete: (id) => api.delete(`/category/delete/${id}`),
};

export default categoryService;
